import type { IEnterprise } from "@bbj-types/enterprise";
import { IconButtonVariant } from "@inputs/button/IconButtonVariant";
import WbIncandescentIcon from "@mui/icons-material/WbIncandescentOutlined";
import { type IconButtonProps, Typography } from "@mui/material";
import { type MouseEventHandler, useState } from "react";
import { OfferCardEnterprisePopover, popoverClasses } from "./styles";

interface IOfferPopover {
  ButtonProps?: Omit<IconButtonProps, "onClick">;
  enterprise: IEnterprise | undefined;
}

export const OfferPopover = ({ ButtonProps, enterprise }: IOfferPopover) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handlePopoverOpen: MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setAnchorEl(evt.currentTarget);
  };

  const handlePopoverClose: MouseEventHandler = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButtonVariant
        variant="elevated"
        size="small"
        {...ButtonProps}
        className={ButtonProps?.className}
        onClick={handlePopoverOpen}
      >
        <WbIncandescentIcon color="primary" />
      </IconButtonVariant>
      <OfferCardEnterprisePopover
        className={popoverClasses.root}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        elevation={0}
      >
        <Typography variant="body1" className={popoverClasses.textDescription}>
          Cette offre a été reliée automatiquement à une entreprise correspondante dans la base de données
          d&apos;Horizon.
        </Typography>
        <Typography variant="body1" className={popoverClasses.textOriginalName}>
          <Typography variant="body1SemiBold">Nom initial sur l&apos;offre importée : </Typography>
          <span className={popoverClasses.uppercase}>{enterprise?.name || "-"}</span>
        </Typography>
      </OfferCardEnterprisePopover>
    </>
  );
};
